import { __decorate, __metadata } from "tslib";
import { IsPhoneNumberWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEmail, IsOptional, IsString, IsUrl } from 'class-validator';
import { MerchantExposeGroup } from '../interface';
export class ReadMerchantContactInfoDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50, example: '+1 234 5678912' }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsPhoneNumberWithLVS(undefined, { groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadMerchantContactInfoDto.prototype, "phone", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50, example: 'https://goparrot.ai' }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsUrl({}, { groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadMerchantContactInfoDto.prototype, "homeUrl", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, example: 'info@gopparot.ai' }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsEmail({}, { groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadMerchantContactInfoDto.prototype, "email", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'America/New_York' }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsString({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadMerchantContactInfoDto.prototype, "defaultTimeZone", void 0);
//# sourceMappingURL=ReadMerchantContactInfoDto.js.map